<template>
  <div class="iframe-page-root">
    <iframe
      name="iframe1"
      :srcdoc="isHttp ? null : $store.state.iframeURL"
      :src="isHttp ? $store.state.iframeURL : null"
      class="iframe-embed bg-dark"
      title="game"
    />
    <div class="iframe-bottom-toolbar d-flex align-items-stretch justify-content-between">
      <van-button
        type="default"
        class="iframe-toolbar-btn"
        block
        round
        @click="toolbarBack"
      >
        <i class="fas fa-arrow-left mr-1"></i>{{ $t('iframe.back') }}
      </van-button>
      <van-button
        type="primary"
        class="iframe-toolbar-btn iframe-toolbar-btn--home"
        block
        round
        @click="toolbarHome"
      >
        <i class="fas fa-home mr-1"></i>{{ $t('iframe.home') }}
      </van-button>
      <van-button
        type="danger"
        class="iframe-toolbar-btn"
        block
        round
        @click="toolbarDeposit"
      >
        <i class="fas fa-wallet mr-1"></i>{{ $t('iframe.deposit') }}
      </van-button>
    </div>
  </div>
</template>
<script>
import { deriveIframeGameTitle } from '@/libs/openGameInIframe';

export default {
  async mounted() {
    if (!this.$store.state.iframeURL) {
      this.$router.push('/home');
    }
  },
  computed: {
    // http(s) and blob: (HTML converted to blob URL, e.g. PGSoft) use src;
    // raw HTML from other callers still uses srcdoc
    isHttp() {
      const u = this.$store.state.iframeURL || '';
      return typeof u === 'string' && (u.startsWith('http') || u.startsWith('blob:'));
    },
  },
  watch: {
    '$store.state.language'() {
      const u = this.$store.state.iframeURL;
      if (!u) return;
      const lang = this.$store.state.language || 'en';
      this.$store.commit('setIframeGameTitle', deriveIframeGameTitle(u, lang));
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.path === '/deposit') {
      next();
      return;
    }
    this.$store.commit('clearIframePlaySession');
    next();
  },
  methods: {
    toolbarHome() {
      this.$store.commit('clearIframePlaySession');
      this.$router.push('/home').catch(() => {});
    },
    toolbarBack() {
      if (window.history.length > 1) {
        this.$store.commit('clearIframePlaySession');
        this.$router.go(-1);
      } else {
        this.toolbarHome();
      }
    },
    toolbarDeposit() {
      this.$router.push('/deposit').catch(() => {});
    },
  },
};
</script>
<style scoped>
.iframe-page-root {
  position: relative;
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: #04090a;
}

.iframe-embed {
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  border: none;
  z-index: 1;
  background: #04090a !important;
}

.iframe-bottom-toolbar {
  flex-shrink: 0;
  gap: 6px;
  padding: 6px 8px calc(6px + env(safe-area-inset-bottom, 0));
  background: linear-gradient(180deg, #0c0a09 0%, #020617 100%);
  border-top: 1px solid rgba(234, 179, 8, 0.25);
  z-index: 1036;
}

.iframe-toolbar-btn {
  flex: 1 1 0;
  min-width: 0;
  font-size: 0.72rem;
  height: auto !important;
  padding: 6px 4px !important;
}

.iframe-toolbar-btn--home {
  background: linear-gradient(135deg, #b45309 0%, #eab308 100%) !important;
  border: none !important;
}
</style>
